<template>
  <v-container>
    <v-layout row wrap>
      <v-flex d-flex xs12 child-flex>
        <h1 class="text-center" id="page-heading">Frequently Asked Questions</h1>
      </v-flex>
    </v-layout>
    <!-- v-layout row wrap
      v-for="(item,i) in tabs"
      :key="i"
      class="margin-bottom"
    >
      <h3 v-html="item.title"></h3>
      <v-flex d-flex xs12 child-flex>
        <v-expansion-panels>
          <v-expansion-panel
            v-for="(row, x) in item.contents"
            :key="x"
          >
            <v-expansion-panel-header expand-icon="mdi-menu-down">{{row.question}}</v-expansion-panel-header>
            <v-expansion-panel-content>
              <span class="faq-inner" v-html="row.answer"></span>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-flex>
    </v-layout -->
    <v-layout row wrap>
      <v-flex d-flex xs12 child-flex>
        <v-expansion-panels>

          <v-expansion-panel
            v-for="(item, i) in tabs"
            :key="i"
          >
            <v-expansion-panel-header expand-icon="mdi-menu-down" class="light-blue-background"><h3 v-html="item.title"></h3></v-expansion-panel-header>
            <v-expansion-panel-content class="light-blue-background">
              <v-expansion-panels>
          
                <v-expansion-panel
                  v-for="(row, x) in item.contents"
                  :key="x"
                >
                  <v-expansion-panel-header expand-icon="mdi-menu-down" class="inner-header">{{row.question}}</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <span class="faq-inner" v-html="row.answer"></span>
                  </v-expansion-panel-content>
                </v-expansion-panel>

              </v-expansion-panels>
            </v-expansion-panel-content>
          </v-expansion-panel>

        </v-expansion-panels>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'FAQ',
  components: {
  },
  created() {
    this.axios.get('/data/faq.json').then((response)=>{
      return this.tabs = response.data.payload
    });
  },
  data: () => ({
    tabs : [],
    active: null
  }),
};
</script>
